import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import {
	CategorySpan,
	NavCategoryLink,
} from './navCategoryBarStyles';
const GiftIcon = loadable(() => import('./GiftIcon'));

class NavCategoryMarkup extends PureComponent {
	render () {
		const {
			slug,
			long,
			short,
			onMouseEnter,
			onMouseLeave,
			type,
			icon,
			linkColor,
			accentColor,
			highlight,
			href,
		} = this.props;
		return (
			<NavCategoryLink
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				linkColor={linkColor}
				accentColor={accentColor}
				highlight={highlight}
				data-slug={slug}
				href={href}>
				<CategorySpan
					linkColor={linkColor}
					accentColor={accentColor}
					catType={type}
					fullText
				>
					{icon && (
						<GiftIcon
							width={24}
							height={24}
							fill={accentColor}
							style={{ paddingRight: 4 }}
						/>
					)}
					{long}
				</CategorySpan>
				<CategorySpan
					accentColor={accentColor}
					catType={type}
					shortText
				>
					{short}
				</CategorySpan>
			</NavCategoryLink>
		);
	}

	static propTypes = {
		slug: PropTypes.string.isRequired,
		long: PropTypes.string.isRequired,
		short: PropTypes.string.isRequired,
		onMouseEnter: PropTypes.func,
		onMouseLeave: PropTypes.func,
		type: PropTypes.oneOf(["campaign", "category", "collection"]),
		icon: PropTypes.bool,
		linkColor: PropTypes.string,
		accentColor: PropTypes.string,
		highlight: PropTypes.bool,
		href: PropTypes.string,
	}

	static defaultProps = {
		type: "category",
		icon: false,
	}
}

export default NavCategoryMarkup;
